import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setStyle, clearStyle } from "./styleSlice"; // ⭐ Import setStyle action
import { getPaymentLinkHeaders } from "../../utils/paymentLinkHeaders"; // Import secure headers utility
import { parseApiError } from "../../utils/paymentLinkErrorHandler"; // Import error handler


const BASE_URL = process.env.REACT_APP_API_URL;

// Async thunk untuk fetch data pembayaran
export const fetchPaymentData = createAsyncThunk(
  "payment/fetchPaymentData",
  async (reffNo, { rejectWithValue, dispatch }) => { // ⭐ Tambahkan dispatch
    try {
      const response = await fetch(`${BASE_URL}/api/payment-link`, {
        method: "POST",
        headers: getPaymentLinkHeaders(),
        body: JSON.stringify({ reff_no: reffNo }),
      });

      if (!response.ok) {
        console.log('error:', response);
        // Parse error to get error_code
        const errorData = await parseApiError(response);
        return rejectWithValue({
          message: errorData.message,
          errorCode: errorData.errorCode,
          httpStatus: errorData.httpStatus,
          paymentData: errorData.paymentData,
        });
      }

      const result = await response.json();
      if (!result.success || !result.data) {
        return rejectWithValue({
          message: "Transaction not found or Expired",
          errorCode: result.error_code || null,
          httpStatus: result.code || 404,
        });
      }

      // ⭐ NEW: Dispatch style ke styleSlice jika ada
      if(process.env.REACT_APP_DEBUG){
        console.log('ini cuy', result.data.PaymentLinkMerchantStyle);
      }


      if (result.data.PaymentLinkMerchantStyle) {
        dispatch(setStyle(result.data.PaymentLinkMerchantStyle));
      }
      else{
        dispatch(clearStyle());
      }

      // Return paymentLink data plus the per-payment-link token used to authenticate
      // every subsequent payment-link API call (check-status, proceed-inquiry, etc).
      return { paymentLink: result.data.paymentLink || result.data, token: result.token };
    } catch (error) {
      return rejectWithValue({
        message: error.message || "An error occurred",
        errorCode: null,
        httpStatus: 500,
      });
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    data: null,
    token: null,
    isLoading: false,
    error: null,
    errorCode: null,
    httpStatus: null,
    errorPaymentData: null,
  },
  reducers: {
    setPaymentData: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
      state.errorCode = null;
      state.httpStatus = null;
      state.errorPaymentData = null;
    },
    // Stores the payment-link-scoped token returned by get-by-reff when a page is
    // opened directly (refresh / reopened link) and had no token in memory yet.
    setPaymentToken: (state, action) => {
      state.token = action.payload;
    },
    clearPaymentData: (state) => {
      state.data = null;
      state.token = null;
      state.isLoading = false;
      state.error = null;
      state.errorCode = null;
      state.httpStatus = null;
      state.errorPaymentData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.errorCode = null;
        state.httpStatus = null;
        state.errorPaymentData = null;
      })
      .addCase(fetchPaymentData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.paymentLink;
        state.token = action.payload.token;
        state.error = null;
        state.errorCode = null;
        state.httpStatus = null;
        state.errorPaymentData = null;
      })
      .addCase(fetchPaymentData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message || action.payload || "An error occurred";
        state.errorCode = action.payload?.errorCode || null;
        state.httpStatus = action.payload?.httpStatus || null;
        state.errorPaymentData = action.payload?.paymentData || null;
      });
  },
});

export const { setPaymentData, setPaymentToken, clearPaymentData } = paymentSlice.actions;
export default paymentSlice.reducer;
